module.exports = __webpack_public_path__ + "img/lg_ring_r_e_0_null@2x.cc12ef8e.png";